import { z, isoZ } from 'my-zod'

export const modelGroupsModel = z.object({
  id: z.number().setLabel('Model Group Id'),
  modelGroupName: z.string().nullable(),
  modelFamilyId: z.number().nullable(),
  isAutoCreated: z.boolean().setLabel('Auto Created'),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable()
})

export type modelGroupsModel = z.infer<typeof modelGroupsModel>
